var _excluded = ["value", "disabled", "style", "className"],
    _excluded2 = ["name", "onChange", "selectedValue"];

var _templateObject, _templateObject2, _templateObject3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useContext } from 'react';
import { bool, oneOfType, string, number, shape } from 'prop-types';
import styled from 'styled-components';
import { hexToRgb } from '@gympass/yoga-common';
import RadioGroupContext from '../../RadioGroupContext';
import { HiddenInput } from '../../../shared';
var Radio = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: block;\n\n  pointer-events: none;\n\n  ", "\n"])), function (_ref) {
  var radio = _ref.theme.yoga.components.radiogroup.radio;
  return "\n      width: " + radio.size + "px;\n      height: " + radio.size + "px;\n\n      border-width: " + radio.size * 0.1 + "px; \n      border-style: solid;\n      border-color: " + radio.backgroundColor + ";\n      border-radius: " + radio.border.radius + "px;\n    ";
});
var Input = styled(HiddenInput)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  top: 0;\n  left: 0;\n\n  width: 100%;\n  height: 100%;\n"])));
var Wrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  ", "\n"])), function (_ref2) {
  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      radiogroup = _ref2.theme.yoga.components.radiogroup;
  var stateColors = {
    hover: checked ? hexToRgb(radiogroup.checked.backgroundColor, 0.25) : hexToRgb(radiogroup.hover.backgroundColor, 0.25),
    focusWithin: hexToRgb(radiogroup.checked.hover.backgroundColor, 0.5),
    active: checked ? hexToRgb(radiogroup.checked.hover.backgroundColor, 0.75) : hexToRgb(radiogroup.hover.backgroundColor, 0.75)
  };
  return "\n    width: " + radiogroup.radio.size + "px;\n    height: " + radiogroup.radio.size + "px;\n\n    &:hover {\n      " + Input + " {\n        cursor: pointer;\n      }\n      " + Radio + " {\n        z-index: 1;\n        box-shadow: 0 0 0 " + radiogroup.radio.size * 0.4 + "px " + stateColors.hover + ";\n        background-color: " + hexToRgb(radiogroup.hover.backgroundColor, 0.25) + ";\n      }\n    }\n\n    &:active {\n      " + Radio + " {\n        box-shadow: 0 0 0 " + radiogroup.radio.size * 0.4 + "px " + stateColors.active + ";\n        background-color: " + hexToRgb(radiogroup.hover.backgroundColor, 0.75) + ";\n      }\n    }\n\n    " + (checked ? "\n    \n      &:hover {\n        " + Radio + " {\n          background-color: " + stateColors.hover + ";\n          box-shadow: 0 0 0 " + radiogroup.radio.size * 0.4 + "px \n            " + stateColors.hover + ";\n        }\n      }\n    \n      &:focus-within {\n        " + Radio + " {\n          z-index: 1;\n          background-color: " + stateColors.focusWithin + ";\n          box-shadow: 0 0 0 " + radiogroup.radio.size * 0.4 + "px \n            " + stateColors.focusWithin + ";\n        }\n      }\n    \n      &:active {\n        " + Radio + " {\n          background-color: " + stateColors.active + ";\n          box-shadow: 0 0 0 " + radiogroup.radio.size * 0.4 + "px \n            " + stateColors.active + ";\n        }\n      }\n\n      " + Radio + " {\n        border-color: " + radiogroup.checked.backgroundColor + ";\n\n        &:after {\n          position: absolute;\n          top: 50%;\n          left: 50%;\n\n          width: " + radiogroup.radio.size * 0.5 + "px;\n          height: " + radiogroup.radio.size * 0.5 + "px;\n          \n          border-radius: 100%;\n          background-color: " + radiogroup.checked.backgroundColor + ";\n          \n          transform: translate(-50%, -50%);\n          \n          content: '';\n        }\n      }\n    " : '') + "\n\n    " + (disabled ? "\n        " + Radio + " {\n          border-color: " + radiogroup.disabled.backgroundColor + ";\n        }\n\n        &:hover {\n          " + Input + " {\n            cursor: not-allowed;\n          }\n          " + Radio + " {\n            box-shadow: none;\n          }\n        }\n      " : "") + "\n\n    " + (disabled && checked ? "\n          " + Radio + ":after {\n            background-color: " + radiogroup.disabled.backgroundColor + ";\n          }\n        " : '') + "\n  ";
});
/** The Radio is a type of selection control that allows the user to select a
 * single option from a list. */

var RadioGroupRadio = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var value = _ref3.value,
      disabled = _ref3.disabled,
      style = _ref3.style,
      className = _ref3.className,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded);

  var _useContext = useContext(RadioGroupContext),
      name = _useContext.name,
      onChange = _useContext.onChange,
      selectedValue = _useContext.selectedValue,
      context = _objectWithoutPropertiesLoose(_useContext, _excluded2);

  var inputValue = value;
  var checked = inputValue === selectedValue;
  return /*#__PURE__*/React.createElement(Wrapper, {
    checked: checked,
    disabled: disabled,
    style: style,
    className: className
  }, /*#__PURE__*/React.createElement(Radio, {
    checked: checked
  }), /*#__PURE__*/React.createElement(Input, _extends({
    type: "radio",
    value: value,
    checked: checked,
    name: name,
    onChange: onChange,
    disabled: disabled,
    ref: ref
  }, rest, context)));
});
RadioGroupRadio.displayName = 'RadioGroup.Radio';
RadioGroupRadio.propTypes = {
  className: string,
  disabled: bool,
  style: shape({}),
  value: oneOfType([string, number])
};
RadioGroupRadio.defaultProps = {
  className: undefined,
  disabled: false,
  style: {},
  value: ''
};
export default RadioGroupRadio;